import { IAppState } from "../core/redux/IAppState";
import { ACTION_TYPE } from "../core/redux/actionType";
import { assoc } from "./module";

export const setDateFormat = (dateFormat: string) => {
    return {
        type: ACTION_TYPE.SET_DATE_FORMAT,
        payload: dateFormat,
    };
};

const dateFormatReducer = (state, action): 
    IAppState => action.type !== ACTION_TYPE.SET_DATE_FORMAT ? state : assoc('defaultDateFormat', action.payload.replaceAll('-', '/'), state);

export default dateFormatReducer;